var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#83a77a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,1A17,17,0,0,0,5.979,30.021,17,17,0,0,0,30.021,5.979,16.889,16.889,0,0,0,18,1m0-1A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5 7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.537.095,14.784,2.21A1.717,1.717,0,0,1,15.96,3.821L16,10.13a7.876,7.876,0,0,1-1.943,5.221,7.955,7.955,0,0,1-2.28,1.752L8.419,18.914A.731.731,0,0,1,8.081,19a.713.713,0,0,1-.337-.082l-3.389-1.77a7.973,7.973,0,0,1-2.3-1.726,7.876,7.876,0,0,1-2.013-5.2L0,3.918A1.721,1.721,0,0,1,1.156,2.292L7.379.1A1.762,1.762,0,0,1,8.537.095Zm2.987,6.763a.719.719,0,0,0-1.005.006h0l-3.17,3.154-1.3-1.259a.719.719,0,0,0-1.005.007.69.69,0,0,0,.007.987h0l1.8,1.751A.72.72,0,0,0,7.86,11.5h0l3.67-3.652A.69.69,0,0,0,11.525,6.858Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.f81ac8cb45c9e900cbca7fd6bf98739f.svg";
export { ForwardRef as ReactComponent };